// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"bd15cda0","531":"c7538ac1","727":"b2c19984","768":"dd7ecda8","835":"7ad67802","852":"2ddea5d7","916":"57160ec9","979":"c2fc00ae"}[chunkId] + ".css";
};